import { format } from 'date-fns'

export const formatDate = (date: string) => {
    const dateInstance = new Date(date)

    return format(dateInstance, 'dd.MM.yyyy')
}
